import {Component, EventEmitter, Input, Output} from "@angular/core";
import {CalendarDaySlot, CalendarTime} from "../../../../../../../../../entities/CalendarDaySlot";

@Component({
    selector: 'leasing-day-slot',
    styleUrls: ['./daySlot.scss'],
    templateUrl: './daySlot.html'
})
export class DaySlotComponent {

    @Input() daySlot:CalendarDaySlot;
    @Input() id:string;
    @Output() selected:EventEmitter<void> = new EventEmitter<void>();

    ngOnInit(){
        this.daySlot.SelectedChanged().subscribe(() => {
            let element = document.getElementById(this.id);
            if(this.daySlot.Selected()){
                element.style.backgroundColor = '#AED581';
            }else{
                element.style.backgroundColor = '#FFFFFF';
            }
        })
    }

    public calendarTimeAsString():string{
        return CalendarTime[this.daySlot.Time()];
    }

    public select(){
        this.daySlot.Click();
        this.selected.emit();
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/leasing/presentation/userReservation/calendar/slot/daySlot/daySlot.ts